import type theme from '#build/ui/breadcrumb'
import type { DeepPartial } from '@nuxt/ui'

const breadcrumb: DeepPartial<typeof theme> = {
  slots: {
    list: 'gap-2',
    link: [
      'group relative flex min-w-0 items-center gap-2 text-base transitions-normal desktop:text-lg',
      'before:absolute before:bottom-0 before:left-1/2 before:h-px before:w-0 before:-translate-x-1/2 before:rounded-full before:bg-cvt-burgundy-500 before:opacity-0 before:transitions-extra-slow',
      'focus-visible:outline-cvt-burgundy-500',
    ] as any,
    separatorIcon: 'text-cvt-text-black',
  },
  variants: {
    active: {
      true: {
        link: 'text-cvt-text-black font-normal',
      },
      false: {
        link: 'text-cvt-burgundy-500 font-normal',
      },
    },
  },
  compoundVariants: [{
    disabled: false,
    active: false,
    to: true,
    class: {
      link: 'hover:text-cvt-burgundy-500 hover:before:w-full hover:before:opacity-100',
    },
  }],
}

export default breadcrumb
